/**
 * **휴대폰 본인확인 창(NICE) — 주소와 돌아온 결과 한 곳.** 의존성 없는 순수 모듈이다(Vue·Element·`@/` 별칭 금지). 창을 띄우고 그 주소를 읽는
 * 효과는 `components/login/PhoneVerifyDialog.vue` 한 곳이다.
 *
 * 쓰는 흐름이 둘이다 — 처음 받은 비밀번호 재설정(`utils/passwordReset` · `PasswordResetPanel`)과 사장님 계정 비밀번호 찾기
 * (`utils/ownerLogin` · `OwnerPasswordReset`). 창은 integration-server 입구이고(qr2-web 성인인증과 같은 창), 끝나면 `pbnext` 로 이 앱의
 * 정적 돌아올 자리(`public/phone-verified.html`)에 `?result=열쇠` 또는 `?error=` 를 싣고 돌아온다. 화면이 같은 출처로 그 주소를 읽는다.
 */

/** 휴대폰 확인 창이 돌아오는 자리 — 앱을 띄우지 않는 정적 파일(`public/phone-verified.html`). 화면이 같은 출처로 그 주소를 읽는다 */
export const PHONE_VERIFY_RETURN_PATH = '/phone-verified.html'

/**
 * 휴대폰 확인 창 주소 — integration-server 창이 끝나면 `pbnext` 로 돌아온다(`?result=열쇠` 또는 `?error=`).
 *
 * @param {string} verificationUrl 창 입구(`utils/constants` 의 `ID_VERIFICATION_URL`)
 * @param {string} origin 이 화면의 출처(`window.location.origin`)
 */
export function phoneVerifyUrl(verificationUrl, origin) {
  return `${verificationUrl}?pbnext=${encodeURIComponent(origin + PHONE_VERIFY_RETURN_PATH)}`
}

/**
 * 창(iframe)이 지금 있는 주소 → 결과. 아직 창 안이면(남의 출처라 못 읽었거나 돌아올 자리가 아니면) `null`.
 *
 * @param {?{origin: string, pathname: string, search: string}} frameLocation 같은 출처일 때만 읽힌 iframe 주소(못 읽었으면 `null`)
 * @param {string} origin 이 화면의 출처
 * @returns {?{verification: string}|{failed: true}}
 */
export function phoneVerifyOutcome(frameLocation, origin) {
  if (!frameLocation || frameLocation.origin !== origin || frameLocation.pathname !== PHONE_VERIFY_RETURN_PATH)
    return null

  const result = new URLSearchParams(frameLocation.search || '').get('result')

  return hasText(result) ? { verification: result } : { failed: true }
}

function hasText(value) {
  return typeof value === 'string' && value.trim() !== ''
}
